/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

davinci-button:focus {
  box-shadow: none;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  outline: none;
  margin: calc(13rem /14) 0;
}
:host > .wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  width: 100%;
}
:host > .wrapper > davinci-button {
  flex: 0 1 auto;
  margin: 0;
  contain: layout;
}
:host > .wrapper > .decrease {
  margin-right: -1px;
}
:host > .wrapper > .increase {
  margin-left: -1px;
}
:host > .wrapper > input {
  font-size: calc(14rem /14);
  flex: 0 1 auto;
  height: calc(46rem /14);
  min-width: calc(72rem /14);
  width: 100%;
  padding: 0 calc(16rem /14);
  text-align: center;
  text-overflow: ellipsis;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
  border: 1px solid var(--davinci-color-outline,#8E989D);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  outline: none;
  z-index: 1;
  border-radius: 0;
}
:host > .wrapper > input:invalid {
  box-shadow: none;
}
:host > .wrapper > input::-ms-clear {
  display: none;
}
:host > .wrapper > input::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
}
:host > .wrapper > input:focus {
  border: 1px solid var(--davinci-color-primary,#007CC1);
}
:host > .wrapper > .unit {
  padding-left: calc(12rem /14);
}

:host([disabled]) > .wrapper > input {
  color: #8E989D;
  color: var(--davinci-color-outline, #8E989D);
  border-color: var(--davinci-color-outline-disabled, );
  pointer-events: none;
}

:host([hidden]) {
  display: none;
}`;
export { style };
